import aesReduxConstants from '../constants';
import productsSelectors from '../selectors/productsSelectors';
import soundActions from '../actions/soundActions';
import productEventActions from '../actions/productEventActions';
import { selectErrorMessageFromResponse } from '../utils/errorUtil';

// checks for products that should be playing and dispatches to the other middleware
export var productSoundMiddleware = function(genericProductFactory) {
  const middleware = function(store) {
    const constants = aesReduxConstants;
    return function(next) {
      return function(action) {
        // let the action pass and then calculate sounds
        next(action);

        const state = store.getState();
        const events = productsSelectors.selectProductEvents(state);
        const eventsPlayingSound = [];
        const eventIdsPlayingSound = [];
        for (let i = 0; i < events.length; i++) {
          const productEvent = events[i];
          const eventsPlayed = productsSelectors.selectEventsPlayedSound(state);
          const { shouldPlay } = genericProductFactory.checkShouldProductPlaySound(productEvent, eventsPlayed);

          if (shouldPlay) {
            eventsPlayingSound.push(productEvent);
            eventIdsPlayingSound.push(productEvent.id);
          }
        }

        // TODO: i dont think we want to dispatch 2 actions everytime there is an action
        next({ type: constants.PLAY_PRODUCT_EVENT_SOUNDS, events: eventsPlayingSound });
        next({ type: constants.SET_EVENTS_PLAYING_SOUND, events: eventIdsPlayingSound });
      };
    };
  };


  return middleware;
};

// handles the management of orchistrating when sounds play and the callbacks on them
export var playProductSoundMiddleware = function(genericProductFactory) {
  const middleware = function(store) {
    const constants = aesReduxConstants;
    return function(next) {
      return function(action) {
        if (action.type === constants.PLAY_PRODUCT_EVENT_SOUNDS) {
          next(action);

          if (action.events.length === 0) {
            next(soundActions.stopAllSounds());
          } else {
            const state = store.getState();
            const eventsPlayingSound = productsSelectors.selectEventsPlayingSound(state);
            // all of the events that should be playing some sound
            for (let i = 0; i < action.events.length; i++) {
              const event = action.events[i];
              // check if the event is already playing
              let isPlaying = false;

              for (let j = 0; j < eventsPlayingSound.length; j++) {
                const playingEventId = eventsPlayingSound[j];
                if (playingEventId === event.id) {
                  isPlaying = true;
                }
              }

              if (!isPlaying) {
                // get the sound actions from the factory
                const eventsPlayed = productsSelectors.selectEventsPlayedSound(state);
                const loop = genericProductFactory.checkShouldProductPlaySound(event, eventsPlayed).shouldLoop;

                next(soundActions.playSound(event.content.soundMediaURL, loop, productEventActions.productEventStoppedPlayingSound(event.id, loop)));
              }
            }
          }
        } else {
          next(action);
        }
      };
    };
  };

  return middleware;
};

// any action that have a meta.sound property will trigger this
// middleware to manage a sound and its life cylce depending on the settings
// in the action such as the following properties
// - media, the sound media the audio needs to play
// - loop, should the sound loop (true false)
// - finished, a redux action object to be called after the sound has finished playing
export var soundMiddleware = function() {
  const soundStore = {
    playOnce: new Audio(),
    loop: new Audio(),
  };

  const middleware = function(store) {
    return function (next) {
      return function(action) {
        // check if the action has the ability to play a sound
        if (action.meta !== undefined && action.meta.sound !== undefined) {
          // sound media url
          const { media } = action.meta.sound;
          // should the sound loop
          const { loop } = action.meta.sound;
          let audio = soundStore.playOnce;
          if (loop) audio = soundStore.loop;


          if (audio.paused === true) {
            audio.src = media;
            audio.loop = loop;
            audio.play();
          }

          // if the action has a finished action set it up to be callled after the sound stopped
          if (
            action.meta.sound.finished !== undefined
            && action.meta.sound.finished !== null
            && typeof action.meta.sound.finished.type === 'string'
          ) {
            audio.addEventListener('ended', () => {
              // call the finished action to show the sound is done
              next(action.meta.sound.finished);
            });
          }
        }

        // these cases should stop the audio elements
        if (action.type === aesReduxConstants.STOP_ALL_SOUNDS) {
          soundStore.loop.pause();
          soundStore.playOnce.pause();
        }

        if (action.type === aesReduxConstants.STOP_LOOPED_AUDIO) {
          soundStore.loop.pause();
        }

        if (action.type === aesReduxConstants.STOP_PLAY_ONCE_AUDIO) {
          soundStore.playOnce.pause();
        }

        // if the action does not have the required meta to trigger this middleware
        // the middleware will not do anything different with the action and just pass it through
        return next(action);
      };
    };
  };

  return middleware;
};

export var errorMiddleware = function(genericModalService) {
  const middleware = function() {
    return function(next) {
      return function(action) {
        if (action.hasOwnProperty('error')) {
          next(action);

          const { error } = action;

          genericModalService.alert({ title: error.title, message: selectErrorMessageFromResponse(error) });
        } else {
          next(action);
        }
      };
    };
  };

  return middleware;
};
